<div class="reading-page order-find-page">
  <div id="head" class="section-header">
    <h2 class="section-title">Find my order</h2>
    <h3 class="section-description">
      Lost your download link? Enter the e-mail address you paid with and we will send your order links again.
    </h3>
  </div>

  <div class="find-card">
    <div *ngIf="sent" class="find-sent" aria-live="polite">
      <app-icon name="envelope-open-text" class="find-sent-icon" aria-hidden="true"></app-icon>
      <p class="find-sent-title">Check your inbox</p>
      <p class="find-sent-text">
        If there are paid orders under <strong>{{ sentTo }}</strong>, an e-mail with their download links is on its way.
        Give it a minute, and look in spam if it does not show up.
      </p>
      <button type="button" class="find-again" (click)="reset()">Use a different address</button>
    </div>

    <form *ngIf="!sent" (ngSubmit)="onSubmit($event)" [formGroup]="form" novalidate>
      <div class="input-with-label" [class.error-input]="submitted && form.controls.email.invalid">
        <input formControlName="email" placeholder="jane.doe@example.com" required type="email" autocomplete="email" inputmode="email"/>
        <h4>E-mail address <span class="required-mark">*</span></h4>
      </div>
      <p class="find-hint">The address you typed at checkout. It is on your Stripe receipt.</p>

      <div class="button-area">
        <button type="submit" class="codigrate-button" [disabled]="sending">
          <p>{{ sending ? 'Sending…' : 'E-mail my order links' }}</p>
        </button>
        <p *ngIf="errorMessage" class="form-message" role="alert">{{ errorMessage }}</p>
      </div>
    </form>
  </div>

  <p class="find-help">
    Still stuck? <a [routerLink]="URLS.contactUs" class="theme-color-link">Contact us</a> with your order number (CG-…) or the receipt e-mail.
  </p>
</div>
